import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import basharaat from "../assets/images/BashaaratLogo.svg";
import api from "../services/api";

const Sidebar = () => {
  const [modules, setModules] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const location = useLocation();

  const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const toggleSubItems = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    loadSidebar();
  }, []);

  useEffect(() => {
    modules.forEach((item, index) => {
      const isChildActive = item.subItems?.some((sub) =>
        location.pathname.startsWith(sub.path)
      );

      if (isChildActive) {
        setOpenIndex(index);
      }
    });
  }, [location.pathname, modules]);

  const loadSidebar = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    if (!admin) return;

    const roleId = admin.roleid;
    const userId = admin.id;

    try {
      let response;

      if (roleId === "1") {
        response = await api.get("https://services.bashaarat.com/modules/list");
      } else {
        response = await api.get(
          `https://services.bashaarat.com/access/get/${userId}`
        );
      }

      const result = await response?.data;
      if (result.status) {
        const grouped = groupModules(result.data);
        // console.log("Sidebar Modules:", result.data);
        setModules(grouped);
      }
    } catch (err) {
      console.error("Sidebar load error", err);
    }
  };

  const groupModules = (data) => {
    const map = {};

    data.forEach((item) => {
      const moduleId = item.module_id;

      if (!map[moduleId]) {
        map[moduleId] = {
          title: item.module_name,
          path: item.moduleurl || item.module_url || "",
          icon: item.moduleicon || item.module_icon,
          subItems: [],
        };
      }

      if (item.sub_module_id) {
        map[moduleId].subItems.push({
          name: item.sub_module_name,
          icon: item.moduleicon,
          path: item.submodleurl || item.sub_module_url,
        });
      }
    });

    return Object.values(map);
  };

  return (
    <div
      className="d-flex flex-column vh-100 "
      style={{
        width: "260px",
        backgroundColor: "white",
      }}
    >
      {/* Logo */}
      <div className="px-3 py-3">
        <Link to="/dashboard">
          <img src={basharaat} alt="Logo" style={{ height: "40px" }} />
        </Link>
      </div>

      <div
        style={{
          paddingTop: "5%",
          overflowY: "auto",
          maxHeight: "calc(100vh - 50px)",
        }}
      >
        {modules.map((item, index) => {
          const isActive = location.pathname.startsWith(item.path);
          const isChildActive = item.subItems.some((sub) =>
            location.pathname.startsWith(sub.path)
          );

          return (
            <div key={index} className="p-1  ">
              {/* 🔹 NO SUBMODULE */}
              {item.subItems.length === 0 && (
                <Link
                  to={item.path}
                  className="d-flex align-items-center px-3 py-2 text-decoration-none gap-2"
                  style={{
                    backgroundColor: isActive ? "#BC6C25" : "transparent",
                    color: isActive ? "#fff" : "#000",
                    borderRadius: "6px",
                  }}
                >
                  {item.icon ? (
                    <img
                      src={`${baseUrl}/${item.icon}`}
                      alt="icon"
                      style={{
                        width: "20px",
                        filter: isActive
                          ? "brightness(0) invert(1)"
                          : "none",
                      }}
                    />
                  ) : null}

                  <span style={{ fontWeight: 700, color: isActive ? "#fff" : "#000" }}>
                    {item.title}
                  </span>
                </Link>
              )}

              {/* 🔹 WITH SUBMODULE */}
              {item.subItems.length > 0 && (
                <>
                  <div
                    onClick={() => toggleSubItems(index)}
                    className="d-flex justify-content-between align-items-center px-3 py-2"
                    style={{
                      cursor: "pointer",
                      backgroundColor: isChildActive
                        ? "#BC6C25"
                        : "transparent",
                      color: isChildActive ? "#fff" : "#000",
                      borderRadius: "6px",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      {item.icon ? (
                        <img
                          src={`${baseUrl}/${item.icon}`}
                          alt="icon"
                          style={{
                            width: "20px",
                            filter: isChildActive
                              ? "brightness(0) invert(1)"
                              : "none",
                          }}
                        />
                      ) : null}

                      <span style={{ fontWeight: 700, color: isChildActive ? "#fff" : "#000" }}>
                        {item.title}
                      </span>
                    </div>

                    <FaChevronDown
                      style={{
                        transform:
                          openIndex === index
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        transition: "0.3s",
                        fill: isChildActive ? "#fff" : "#000",
                      }}
                    />
                  </div>

                  {/* SUBMODULES */}
                  {openIndex === index && (
                    <div className="text-center">
                      {item.subItems.map((sub, subIndex) => {
                        const isSubActive =
                          location.pathname.startsWith(sub.path);

                        return (
                          <div key={subIndex} className="py-1">
                            <Link
                              to={sub.path}
                              className="d-flex align-items-center px-2 py-1 text-decoration-none"
                              style={{
                                backgroundColor: isSubActive
                                  ? "#BC6C25"
                                  : "transparent",
                                color: isSubActive ? "#fff" : "#000",
                                borderRadius: "6px",
                              }}
                            >
                              <span style={{ fontWeight: 600, color: isSubActive ? "#fff" : "#000" , paddingLeft:"20%"   }}>
                                {sub.name}
                              </span>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;